/**
 * @generated SignedSource<<e041c8794ba88f35f419aedf1cfb86bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskScreenComponent_topics$data = ReadonlyArray<{
  readonly id: string;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItem_topics" | "TaskConnections_topics">;
  readonly " $fragmentType": "TaskScreenComponent_topics";
}>;
export type TaskScreenComponent_topics$key = ReadonlyArray<{
  readonly " $data"?: TaskScreenComponent_topics$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskScreenComponent_topics">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TaskScreenComponent_topics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditMainOrgTopicListItem_topics"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskConnections_topics"
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "8f76f36a13c9136ace7f2bf691c46412";

export default node;
